/**
 * Number formatting shared by the analytics sections. Every formatter takes
 * the active i18n locale; none hard-codes one.
 */

/**
 * The metrics pack carries amounts without a currency code. They are the
 * Shopify shop's amounts, which are USD — the same default `formatCurrency`
 * (`@/lib/utils`) applies.
 */
const REPORT_CURRENCY = 'USD';

export function formatCount(value: number, locale: string | undefined): string {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(value);
}

export function formatRate(value: number, locale: string | undefined): string {
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 1 }).format(
    value,
  );
}

export function formatMoney(
  value: number,
  locale: string | undefined,
  { compact = false }: { compact?: boolean } = {},
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: REPORT_CURRENCY,
    // "$" rather than the CLDR "US$" some locales (zh) print.
    currencyDisplay: 'narrowSymbol',
    ...(compact ? { notation: 'compact', maximumFractionDigits: 2 } : {}),
  }).format(value);
}

export function formatDateTime(value: string, locale: string | undefined): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(value),
  );
}
